import { createStore } from 'vuex'
import { authService, pipelineService, executionService, moduleService } from '../services/services'
import jwtDecode from 'jwt-decode'

export default createStore({
  state: {
    token: localStorage.getItem('token') || null,
    user: null,
    pipelines: [],
    executions: [],
    modules: [],
    currentPipeline: null,
    currentExecution: null,
    loading: false,
    error: null
  },

  getters: {
    isAuthenticated: state => !!state.token,
    getUser: state => state.user,
    isAdmin: state => state.user?.is_admin === true, // 👈 aqui o check
    getPipelines: state => state.pipelines,
    getExecutions: state => state.executions,
    getModules: state => state.modules,
    getCurrentPipeline: state => state.currentPipeline,
    getCurrentExecution: state => state.currentExecution,
    isLoading: state => state.loading,
    getError: state => state.error
  },

  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      if (token) localStorage.setItem('token', token)
      else localStorage.removeItem('token')
    },
    SET_USER(state, user) {
      state.user = user
    },
    SET_PIPELINES(state, pipelines) {
      state.pipelines = pipelines
    },
    SET_EXECUTIONS(state, executions) {
      state.executions = executions
    },
    SET_MODULES(state, modules) {
      state.modules = modules
    },
    SET_CURRENT_PIPELINE(state, pipeline) {
      state.currentPipeline = pipeline
    },
    SET_CURRENT_EXECUTION(state, execution) {
      state.currentExecution = execution
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },

  actions: {
    async login({ commit }, credentials) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        const response = await authService.login(credentials)
        const token = response.data.access_token
        commit('SET_TOKEN', token)

        // 🔍 Decodifica o JWT e armazena `is_admin`
        const decoded = jwtDecode(token)
        commit('SET_USER', {
          id: decoded.sub,
          is_admin: decoded.is_admin || false
        })

        return true
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.detail || 'Erro ao fazer login')
        return false
      } finally {
        commit('SET_LOADING', false)
      }
    },

    logout({ commit }) {
      commit('SET_TOKEN', null)
      commit('SET_USER', null)
      commit('SET_PIPELINES', [])
      commit('SET_EXECUTIONS', [])
      commit('SET_MODULES', [])
      commit('SET_CURRENT_PIPELINE', null)
      commit('SET_CURRENT_EXECUTION', null)
    },

    checkAuth({ commit, state }) {
      if (!state.token) return
      try {
        const decoded = jwtDecode(state.token)
        const currentTime = Date.now() / 1000

        if (decoded.exp < currentTime) {
          commit('SET_TOKEN', null)
          commit('SET_USER', null)
        } else {
          commit('SET_USER', {
            id: decoded.sub,
            is_admin: decoded.is_admin || false
          })
        }
      } catch {
        commit('SET_TOKEN', null)
        commit('SET_USER', null)
      }
    }
  }
})
